import { Tag as AntdTag } from "antd";
import React from "react";
import classnames from "classnames";
import styles from "./Tag.module.scss";

type tagColor = "yellow" | "red" | "green";
export interface ITag {
  className?: string;
  color?: tagColor;
  icon?: React.ReactNode;
  children?: React.ReactNode;
  onClick?: (e: React.MouseEvent) => void;
}

export const Tag: React.FC<ITag> = ({
  onClick,
  color,
  className,
  icon,
  children,
}) => {
  const classColor = `${color?.[0].toUpperCase()}${color?.slice(1)}`;
  return (
    <AntdTag
      icon={icon ?? null}
      className={classnames(styles.tag, className, {
        [styles[`tag${classColor}`]]: color,
      })}
      onClick={onClick}
    >
      {children}
    </AntdTag>
  );
};
